import React, { useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import Apis from '../../api';
import { RootState } from '../../store/rootReducer';
import HSButton from '../common/Button';
import MessageActions from '../message/redux/actions';

const SignUpThankYou: React.FC = () => {
    const email = useSelector((state: RootState) => state.user.user?.email);
    const dispatch = useDispatch();

    const [loading, setLoading] = useState(false);

    const resendAccountActivationEmail = () => {
        setLoading(true);
        Apis.resendActivationEmail({
            email: email && email.trim(),
        })
            .then(() => {
                dispatch(
                    MessageActions.showMessage({ error: false, text: 'Account Activation email sent successfully' }),
                );
            })
            .catch((err) => {
                dispatch(MessageActions.showMessage({ error: true, text: String(err) }));
            })
            .finally(() => {
                setLoading(false);
            });
    };

    return (
        <div className="h-full flex justify-center items-center">
            <div className="w-full" id="signUp">
                <div>
                    <p className="text-base text-center">Thank you for registering on our platform</p>
                    <p className="text-base text-center mt-4">
                        An Account Activation email has been sent to your email id{' '}
                        <span className="text-blue-400">{email}</span>
                    </p>
                    <p className="mt-4 text-base text-center">
                        If you haven't received this email, please click below to resend (sometimes system generated
                        emails can go into Spam instead of Inbox, so please check your Spam email folder, in case you do
                        not receive this email in your Inbox, even after resending)
                    </p>
                    <div className="mt-9 flex justify-center items-center pb-4">
                        <HSButton
                            onClick={resendAccountActivationEmail}
                            title="Resend Activation Email"
                            loading={loading}
                        />
                    </div>
                </div>
            </div>
        </div>
    );
};

export default SignUpThankYou;
